module.exports = __webpack_public_path__ + "h5/img/brandtitbg.df3ca7c7.png";